import React from "react";
import { motion } from "framer-motion";
import { PenLine, Wand2, Download } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export default function HowItWorks() {
  const { t } = useI18n();
  const steps = [
    { icon: PenLine, title: t("landing.step1Title"), desc: t("landing.step1Desc") },
    { icon: Wand2, title: t("landing.step2Title"), desc: t("landing.step2Desc") },
    { icon: Download, title: t("landing.step3Title"), desc: t("landing.step3Desc") },
  ];

  return (
    <section id="how-it-works" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="max-w-xl font-heading text-2xl font-medium tracking-tight sm:text-3xl lg:text-4xl">
          {t("landing.stepsTitle")}
        </h2>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="relative rounded-2xl border border-border bg-card p-8"
              data-testid={`landing-step-${i + 1}`}
            >
              <span className="font-heading text-5xl font-light text-primary/25">0{i + 1}</span>
              <div className="mt-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <step.icon className="h-6 w-6" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-heading text-xl font-medium">{step.title}</h3>
              <p className="mt-2 text-base leading-relaxed text-muted-foreground">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
